export default "__VITE_ASSET__d742374f__"